import React from "react";
import { useFetchUserEquipmentsQuery } from "../../../store";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ListHeader from "../../applicationManagement/managementShared/ListHeader";

const Equipments = ({ userId }) => {
  const { data } = useFetchUserEquipmentsQuery(userId);
  console.log(data);
  return (
    <Box sx={{ mt: 4 }}>
      <ListHeader text="Zimmetler" />
      {data?.data.map((product) => (
        <Card
          sx={{
            height: "100%",
            display: "flex",
            mt: 1,
            flexDirection: "row",
            transition: "0.3s",
            "&:hover": {
              boxShadow: 6, // Hover efektinde gölgeyi artır
              transform: "translateY(-4px)", // Hafif yukarı hareket
            },
          }}
        >
          <CardContent>
            {/* Model Adı - En belirgin başlık */}
            <Typography
              variant="h6"
              component="div"
              gutterBottom
              color="primary"
              fontWeight="bold"
            >
              {product.categoryName}
            </Typography>

            {/* Marka Adı */}
            <Typography
              variant="subtitle1"
              color="text.secondary"
              sx={{ mb: 1.5 }}
            >
              Marka: {product.brandName}
            </Typography>

            {/* Kategori Adı */}
            <Typography variant="body2" color="text.secondary">
              Model: {product.modelName}
            </Typography>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default Equipments;
